import React from 'react';
import { NavHeader } from '../components/nav/NavHeader';
import RolePermissionTable from '../modules/userManagement/views/RolePermissionTable';
import { UnthinkableSectionTable } from '../modules/common/views/UnthinkableSectionTable';
import { UnthinkableSandboxSectionTable } from '../modules/common/views/UnthinkableSandboxSectionTable';
import { WebsiteMenu } from '../modules/common/views/WebsiteMenu';
import { RoleForm, EditRoleForm } from '../modules/userManagement/views/RoleForm';
import { AppRoleForm, EditAppRolesForm } from '../modules/userManagement/views/AppRoleForm';
import { AppResourceForm, EditAppResourceForm } from '../modules/userManagement/views/AppResourceForm';
import { RolePermissionForm, EditRolePermissionForm } from '../modules/userManagement/views/RolePermissionForm';
import { RolePermissionFormDataEntity, EditRolePermissionFormDataEntity } from '../modules/userManagement/views/RolePermissionFormDataEntity';
import { UserRoleForm, EditUserRoleForm } from '../modules/userManagement/views/UserRoleForm';
import { AddUnthinkablePageForm, UpdateUnthinkablePageForm } from '../modules/common/views/UnthinkablePagesForm';
import { AddSectionForm, UpdateSectionForm } from '../modules/common/views/SectionForm';
import { ProfileDetail } from '@unthinkable/react-login';
import { LeftMenuNewView } from '../components/menu/LeftMenuNewView';
import { AddWebsiteForm, UpdateWebsiteForm } from '../modules/common/views/WebsiteForm';
import { AddBlogsForm, UpdateBlogsForm } from '../modules/common/views/BlogsForm';


export const stackScreens = [
  {
    name: 'view-role-permission',
    component: RolePermissionTable,
    options: {
      header: props => (
        <NavHeader
          title={`Role Permission (${props?.route?.params?.row?.display_label})`}
          {...props}
        />
      ),
    },
  },
  {
    name: 'section-table',
    component: UnthinkableSectionTable,
    options: {
      header: props => (
        <NavHeader
          back
          navigation={props?.navigation}
          route={{
            ...props.route,
          }}
          title={`${props?.route?.params?.name || ''} Page Sections `}
        />
      ),
    },
  },
  {
    name: 'sandbox-section-table',
    component: UnthinkableSandboxSectionTable,
    options: {
      header: props => (
        <NavHeader
          back
          navigation={props?.navigation}
          route={{
            ...props.route,
          }}
          title={`${props?.route?.params?.name || ''} Page Sections `}
        />
      ),
    },
  },
];

export const leftMenuScreens = [
  {
    name: 'app-module',
    path: ':appModule_id/:itemId/:screenId/:tabId?',
    component: LeftMenuNewView,
    options: {
      header: props => <NavHeader {...props} />,
    },
  },
  {
    name: 'page-menu',
    component: WebsiteMenu,
    options: {
      header: props => (
        <NavHeader
          {...props}
          title={`${props?.route?.params?.row?.domain || ''} Pages`}
        />
      ),
    },
  },
];

export const modalScreens = [];

export const formModalScreens = [
  {
    name: 'add-roles',
    component: RoleForm,
    options: { size: 'small' },
  },
  {
    name: 'edit-roles',
    component: EditRoleForm,
  },
  {
    name: 'add-app-role',
    component: AppRoleForm,
    options: { size: 'medium' },
  },
  {
    name: 'edit-app-role',
    component: EditAppRolesForm,
    options: { size: 'medium' },
  },
  {
    name: 'add-app-resource',
    component: AppResourceForm,
    options: { size: 'medium' },
  },
  {
    name: 'edit-app-resource',
    component: EditAppResourceForm,
    options: { size: 'medium' },
  },
  {
    name: 'add-role-permissions-data-entity',
    component: RolePermissionFormDataEntity,
    options: { size: 'medium' },
  },
  {
    name: 'add-role-permissions',
    component: RolePermissionForm,
    options: { size: 'medium' },
  },
  {
    name: 'edit-role-permissions',
    component: EditRolePermissionForm,
    options: { size: 'medium' },
  },
  {
    name: 'edit-role-permissions-data-entity',
    component: EditRolePermissionFormDataEntity,
    options: { size: 'medium' },
  },
  {
    name: 'add-user-role',
    component: UserRoleForm,
    options: { size: 'small' },
  },
  {
    name: 'edit-user-role',
    component: EditUserRoleForm,
    options: { size: 'small' },
  },
  {
    name: 'add-page',
    component: AddUnthinkablePageForm,
    options: { size: 'medium' },
  },
  {
    name: 'edit-page',
    component: UpdateUnthinkablePageForm,
    options: { size: 'medium' },
  },
  {
    name: 'add-section',
    component: AddSectionForm,
    options: { size: 'medium' },
  },
  {
    name: 'edit-section',
    component: UpdateSectionForm,
    options: { size: 'medium' },
  },
  {
    name: 'add-website',
    component: AddWebsiteForm,
    options: { size: 'medium' },
  },
  {
    name: 'edit-website',
    component: UpdateWebsiteForm,
    options: { size: 'medium' },
  },
  {
    name: 'add-blog-unthinkable',
    component: AddBlogsForm,
    options: { size: 'medium' },
  },
  {
    name: 'edit-blog-unthinkable',
    component: UpdateBlogsForm,
    options: { size: 'medium' },
  },
];
